import { Progress } from "@/components/ui/progress";
import { displayEventTime } from "@/lib/datetime";

interface EventCapacityProps {
  booked: number;
  capacity: number;
  isRefundable: boolean;
  startTime: string;
  showProgress?: boolean;
  timezone?: string;
  isInProgress?: boolean;
  attendees?: Array<{ id: string; first_name: string; quantity: number }>;
}

const EventCapacity = (props: EventCapacityProps) => {
  const { booked, capacity, isRefundable, startTime, showProgress = true, timezone, isInProgress = false, attendees = [] } = props;

  const progress = (booked / capacity) * 100;
  const spotsAvailable = capacity - booked;

  if (isInProgress) {
    return (
      <div className="bg-white rounded-lg p-4 shadow-md mb-4">
        <div className="flex items-center justify-between mb-2">
          <h2 className="font-semibold">Capacity</h2>
          <span className="text-sm text-gray-500">
            {booked} {booked === 1 ? "ticket" : "tickets"} sold
          </span>
        </div>
        <Progress value={progress} className="mb-3" />
        {attendees.length > 0 && (
          <div className="flex flex-wrap gap-2 mb-3">
            {attendees.map((a) => (
              <span key={a.id} className="inline-flex items-center rounded-full bg-muted px-3 py-1 text-sm capitalize text-foreground">
                {a.first_name}
                {a.quantity > 1 && ` (+${a.quantity - 1})`}
              </span>
            ))}
          </div>
        )}
        <p className="text-sm text-gray-500">
          This event is in progress. Book early next time to secure your spot!
        </p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg p-4 shadow-md mb-4">
      <div className="flex items-center justify-between mb-2">
        <h2 className="font-semibold">Capacity</h2>
        <span className="text-sm text-gray-500">
          {spotsAvailable} spots available
        </span>
      </div>
      {showProgress && <Progress value={progress} className="mb-2" />}
      <p className="text-sm text-gray-500">
        {isRefundable
          ? "Minimum attendance required 3 days before event"
          : "Event is confirmed and no longer refundable"}
      </p>
      <p className="text-sm font-medium mt-2">
        Event date: {displayEventTime(startTime, timezone)}
      </p>
    </div>
  );
};

export default EventCapacity;